import React from 'react'
import { Outlet } from 'react-router-dom'
import { Box, Container } from '@mui/material'
import SuperadminNavbar from './SuperadminNavbar'

const SuperadminDashboard = () => {
  return (
    <Box className='App'>
        <SuperadminNavbar />
        <Box sx={{px: 7, pt: 4}}>
        <Outlet />
        </Box>
    </Box>
  )
}

export default SuperadminDashboard